import { fromJS } from 'immutable';

import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_TRAVEL_INTERRUPTION_STATE,
  GET_FLIGHT_STATUS_REQUEST,
  GET_FLIGHT_STATUS_SUCCESS,
  GET_FLIGHT_STATUS_ERROR,
} from './constants';

// The initial state of the App
const initialState = fromJS({
  form: {
     // Travel Cancellation
    tripCancellation: 'false',
    reasonForTripCancellation: [],
    areYouCancellingTheTripDueToMedicalReasons: 'false',
    dateTravelCancellation: '',
    reasonForTravelCancellation: '',
    nameOfPersonHavingSicknessTravelCancellation: '',
    dateOfBirthTravelCancellation: '',
    relationshipToClaimantTravelCancellation: '',
    dateSicknessOrInjuryBeganTravelCancellation: '',
    dateEndedTravelCancellation: '',
    natureOfSicknessOrInjuryTravelCancellation: '',
    lossInformationItemsTravelCancellation: [],
    fromDateTravelCancellation: '',
    toDateTravelCancellation: '',
    insuredsTravelCancellation: [],
    enableTimeTravelCancellation: null,
    // Flight Status API
    flightNumber: '',
    flightDate: '',
    flighDetailsWeatherRelated: {
      success: null,
      flightNumber: null,
      flightDate: null,
      departureDelay: null,
      arrivalDelay: null,
      originAirport: null,
      destinationAirport: null,
      airline: null,
      scheduledOut: null,
      scheduledIn: null,
      status: null,
      cancelled: null,
      error: null,
    },
    onPendingFlighAPIRequest: false,
    onSuccessFlighAPIRequest: false,
    callFailFlighAPIRequest: false,
    manuallyEnterFlight: false,
    typeOfTransportTravelCancellation: '',
    // Cruise Line
    cruiseLineDetailsWeatherRelated: {
      cruiseLine: null,
      cruiseNumber: null,
      departureDate: null,
      arrivalDate: null,
      departurePort: null,
      arrivalPort: null,
    },
    // Trip Cancellation for Any Reason
    tripCancellationForAnyReason: 'false',
    areYouCancellingTheTripDueToMedicalReasonsForAnyReason: 'false',
    dateTripCancellationForAnyReason: '',
    reasonForTripCancellationForAnyReason: '',
    lossInformationItemsTripCancellationForAnyReason: [],
    toDateTripCancellationForAnyReason: '',
    insuredsTripCancellationForAnyReason: [],
    travelSuppliersTripCancellationForAnyReason: [],

    // Travel Interruption
    travelInterruption: 'false',
    reasonsForTripInterruption: [],
    enableTimeInterruption: null,
    dateTripInterrupted: '',
    reasonForInterruption: '',
    nameOfPersonHavingSickness: '',
    dateOfBirth: '',
    relationshipToClaimant: '',
    dateSicknessOrInjuryBegan: '',
    dateEnded: '',
    natureOfSicknessOrInjury: '',
    periodOfHospitalization: '',
    lossInformationItems: [],
    fromDate: '',
    toDate: '',
    insuredsForInterruption: [],
    travelSuppliersTravelInterruption: [],

    // Travel Delay
    travelDelay: 'false',
    didTheDelayOccurDuringDeparture: null,
    didTheDelayOccurDuringArrival: null,
    reasonsForDelay: [],
    dateYouWereDueToDepart: '',
    timeYouWereDueToDepart: null,
    dateTripWasDelayed: '',
    dateDelayEnded: '',
    dateYouActuallyDeparted: '',
    timeYouActuallyDeparted: null,
    delayInformationItems: [],
    detailsRegardingYourTripDelay: '',
    scheduledDateOfDeparture: '',
    scheduledTimeOfDeparture: null,
    actualDateOfDeparture: '',
    actualTimeOfDeparture: null,
    scheduledDateOfArrival: '',
    scheduledTimeOfArrival: null,
    actualDateOfArrival: '',
    actualTimeOfArrival: null,

    // Missed Connection
    missedConnection: 'false',
    reasonsForMissedConnection: [],
    didTheDelayOccurDuringDepartureForMissedConnection: null,
    didTheDelayOccurDuringArrivalForMissedConnection: null,
    scheduledDateOfDepartureForMissedConnection: '',
    scheduledTimeOfDepartureForMissedConnection: null,
    scheduledDateOfArrivalForMissedConnection: '',
    scheduledTimeOfArrivalForMissedConnection: null,
    detailsRegardingYourMissedConnection: '',
    missedConnectionInformationItems: [],
    actualDateOfDeparturForMissedConnection: '',
    actualTimeOfDepartureForMissedConnection: null,
    actualDateOfArrivalForMissedConnection: '',
    actualTimeOfArrivalForMissedConnection: null,
  },
  errors: [],
});

const initialTravelInterruptionState = {
  form: {
    travelInterruption: 'false',
    reasonsForTripInterruption: [],
    addressTravelInterruption: '',
    dateTripInterrupted: '',
    nameOfPersonHavingSickness: '',
    dateOfBirth: '',
    relationshipToClaimant: '',
    dateSicknessOrInjuryBegan: '',
    dateEnded: '',
    natureOfSicknessOrInjury: '',
    periodOfHospitalization: '',
    lossInformationItems: [],
    fromDate: '',
    toDate: '',
  },
};

function changesToYourJourneyStepReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      return action.payload
        ? fromJS({ form: action.payload, errors: [] })
        : initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    case RESET_TRAVEL_INTERRUPTION_STATE:
      return state
           .setIn(['form', 'lossInformationItems'], [])
           .mergeDeep(initialTravelInterruptionState);
    case GET_FLIGHT_STATUS_REQUEST:
      return state
        .setIn(['form', 'onPendingFlighAPIRequest'], true)
        .setIn(['form', 'onSuccessFlighAPIRequest'], false)
        .setIn(['form', 'CellFialFlighAPIRequest'], false)
        .setIn(['form', 'flighDetailsWeatherRelated'], fromJS({
          success: null,
          flightNumber: null,
          flightDate: null,
          departureDelay: null,
          arrivalDelay: null,
          originAirport: null,
          destinationAirport: null,
          Airline: null,
          scheduledOut: null,
          scheduledIn: null,
          status: null,
          cancelled: null,
          error: null,
        }));
    case GET_FLIGHT_STATUS_SUCCESS:
      return state
        .setIn(['form', 'onPendingFlighAPIRequest'], false)
        .setIn(['form', 'onSuccessFlighAPIRequest'], true)
        .setIn(['form', 'callFailFlighAPIRequest'], false)
        .setIn(['form', 'flighDetailsWeatherRelated'], fromJS({
          ...action.payload,
          success: true,
          error: null,
        }));
    case GET_FLIGHT_STATUS_ERROR:
      return state
        .setIn(['form', 'onPendingFlighAPIRequest'], false)
        .setIn(['form', 'onSuccessFlighAPIRequest'], false)
        .setIn(['form', 'callFailFlighAPIRequest'], true)
        .setIn(['form', 'flighDetailsWeatherRelated'], fromJS({
          success: false,
          key: false,
          flightNumber: null,
          flightDate: null,
          departureDelay: null,
          arrivalDelay: null,
          originAirport: null,
          destinationAirport: null,
          Airline: null,
          scheduledOut: null,
          scheduledIn: null,
          status: null,
          cancelled: null,
          error: action.error,
        }));
    default:
      return state;
  }
}

export default changesToYourJourneyStepReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.ChangesToYourJourney/reducer.js